
export const TOGGLE = 'TOGGLE_SIDEBAR'
export const ADMISSIONID = 'ADMISSION_ID'
